import { Accordion, AccordionDetails, AccordionGroup, AccordionSummary, Autocomplete, Badge, Button, Chip, CircularProgress, Input, Link, List, ListItem, ListItemButton, ListItemContent, ListItemDecorator, Modal, ModalClose, ModalDialog, Option, Select, Sheet, Stack, Switch, Table, Tooltip, Typography } from "@mui/joy";

//componentes
import Header from "../../../../components/Header";
import Sidebar from "../../../../components/Sidebar";
import { useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { api } from "../../../../services/api";
import { toast } from "react-toastify";
import { LuTimerReset, LuUser } from "react-icons/lu";
import { IoLocationOutline } from "react-icons/io5";
import { MdAccessTime, MdDateRange, MdOutlineRefresh, MdSearch } from "react-icons/md";
import { TrendingUp, BarChart3, ClockAlert } from "lucide-react";
import { BarChart, XAxis, YAxis, CartesianGrid, Bar, Cell, LabelList, Tooltip as RechartsTooltip, PieChart, Pie, ResponsiveContainer, Legend } from 'recharts'; 
import { dataAtual, decimalParaHora, formatarData } from "../../../../utils/datas";
import MultipleSelect from 'react-select';
import { consultaListaLeadTime } from "../../../../utils/buscaDadosLaravel";

const criterioOptions = [
  { value: 'ES', label: 'Estoque' },
  { value: 'UR', label: 'Urgente' },
  { value: 'MP', label: 'Máquina Parada' },
  { value: 'NO', label: 'Normal' },
  {value : 'ALL', label: 'Todos' }
]

const tiposProcessos = [
    {value: '', label: 'Todos'},
    {value: 'com_os', label: 'Com OS'},
    {value: 'sem_os', label: 'Sem OS'},
]

const tiposPedidoOptions = [
]

const CRITERIO_COLORS = {                                                                                                                                                                                         
    'Estoque': '#1565c0',                                                                                                                                                                                              
    'Máquina Parada': '#c62828',                                                                                                                                                                                              
    'Normal': '#2e7d32',                                                                                                                                                                                              
    'Urgente': '#e65100',
}

export default function AcompanhamentoTempo() {

    const mobile = useMediaQuery('(max-width:1200px)');
    const permissoes = JSON.parse(localStorage.getItem('usuario')).user.autenticacao;

    const [obras, setObras] = useState([]);
    const [obraSelecionada, setObraSelecionada] = useState();
    const [criterio, setCriterio] = useState([{value : 'ALL', label: 'Todos' }]);

    const [dataInicial, setDataInicial] = useState(dataAtual(-1));
    const [dataFinal, setDataFinal] = useState(dataAtual());
    const [modalProcessos, setModalProcessos] = useState(false);
    const [modalProcessosPorEtapa, setModalProcessosPorEtapa] = useState(false);
    const [dadosEtapaConsultada, setDadosEtapaConsultada] = useState();
    const [aprovadores, setAprovadores] = useState();
    const [usuarios, setUsuarios] = useState();
    const [aprovador, setAprovador] = useState();
    const [cards, setCards] = useState({ mediaGlobal: 0, totalProcessos: 0, duracaoMedia: 0, etapaMaisLonga: '...', mediaGlobalPorEtapa: [], carregado: false, solicitacoesDetalhadas: [], fluxosConsiderados: [] });
    const [loading, setLoading] = useState(false);
    const [ordenarDecrescente, setOrdenarDecrescente] = useState(false);
    const [buscaAtrasados, setBuscaAtrasados] = useState(false);
    const [idsProcessos, setIdsProcessos] = useState();
    const [tiposPedido, setTiposPedido] = useState([]);
    const [tiposPedidoOptions, setTiposPedidoOptions] = useState([]);
    const [tiposPedidoSelected, setTiposPedidoSelected] = useState([{value: 'ALL', label: 'Todos'}]);
    //const [dadosGrafico, setDadosGrafico] = useState({ inner: [], outer: [], carregado: false });
    const [dadosGrafico, setDadosGrafico] = useState({ dados: [], criterios: [], carregado: false });
    const [qtdDiasAtraso, setQtdDiasAtraso] = useState(2);
    const [atrasoSelecionado, setAtrasoSelecionado] = useState("2");

    useEffect(() => {
        if (!permissoes.includes("gestao")) {
            window.location.href = "/centralTarefas"
            return;
        }
        else {
            obterLocaisDeEstoque();
            obterAprovadores();
            obterUsuarios();
            buscarCriterioCentroCusto();
            const carregarTipoPedido = async () => {
                const dados = await consultaListaLeadTime(JSON.parse(localStorage.getItem('usuario')).token);
                //i need mount tiposPedidoOptions based on dados, but keeping the "Todos" option at the top of the list
                const tiposPedidoOptionsComTodos = [{ value: 'ALL', label: 'Todos' }, ...dados];
                setTiposPedidoOptions(tiposPedidoOptionsComTodos);
                setTiposPedido(dados);
            };
            carregarTipoPedido();
        }
    }, []);


    useEffect(() => {
        tempoMedioEntreEtapas();
    },[buscaAtrasados, qtdDiasAtraso, ordenarDecrescente]);
        


    const obterLocaisDeEstoque = async () => {
        toast.loading("Buscando locais de estoque...", { toastId: 1 });
        const usuario = JSON.parse(localStorage.getItem('usuario')).user.login;
        const token = JSON.parse(localStorage.getItem('usuario')).token;

        // api.get(`/locaisEstoque?login=${usuario}&coligada=${1}&filial=${1}&solicitacao=`, {
        api.get(`/todosLocaisEstoque?login=${usuario}&coligada=${'%'}&filial=${'%'}&solicitacao=`, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }
        ).then(function ({ data }) {
            let obras = [{ localEstoque: '', nomeLocal: 'Todos' }];
            data.forEach(localEstoque => {
                if (!obras.find(o => o.localEstoque == localEstoque.LOCALESTOQUE.split(' - ')[0])) {
                    obras.push({
                        localEstoque: localEstoque.LOCALESTOQUE.split(' - ')[0],
                        nomeLocal: localEstoque.LOCALESTOQUE.split(' - ')[1]
                    });
                }
            });
            // obras = obras.concat(data.data.LOCALESTOQUE);
            setObras(obras);
        }).catch(error => {
            toast.error(JSON.stringify(error));
        }).finally(() => {
            toast.dismiss();
        })
    }

    const obterAprovadores = async () => {
        const result = await api.get('somenteUsuariosAprovadores');
        if (result.status === 200) {
            setAprovadores(result.data.map(data => ({ label: data.nome, value: data.id })));
        }
    }

    const obterUsuarios = async () => {
        const result = await api.get('usuarios');
        if (result.status === 200) {
            setUsuarios(result.data.data.map(data => ({ label: data.nome, value: data.id })));
        }
    }

    const analisarEtapa = (data) => {
        setDadosEtapaConsultada(data);
        setModalProcessosPorEtapa(true);
    }

    const tempoMedioEntreEtapas = async () => {
        setLoading(true);
        const token = JSON.parse(localStorage.getItem('usuario')).token;
        let _criterio = criterio.map(item => item.value).join(",");
        let _tiposPedido = tiposPedidoSelected.map(item => item.value).join(",");

        try {
            const response = await api.get(`tempoMedioEntreEtapas?data_inicio=${dataInicial}&data_fim=${dataFinal}&aprovador=${aprovador?.value || ""}&localEstoque=${obraSelecionada || ""}&ordenarDecrescente=${ordenarDecrescente ? 'true' : 'false'}&criterio=${_criterio}&solicitacao=${idsProcessos || ""}&tipoPedido=${_tiposPedido}&atrasados=${buscaAtrasados ? 'true' : 'false'}&qtdDiasAtraso=${qtdDiasAtraso || ""}`, {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }
            );
            if (response.status === 200) {
                
                let mediaDiasPorEtapa = response.data.medias_por_etapa.filter(m => m.media_dias > 0);
                mediaDiasPorEtapa = mediaDiasPorEtapa.map(mpe => (
                                                                    { 
                                                                        etapa: mpe.etapa == 'Compras' ? 'Envio do MCP' : mpe.etapa == 'Comprador' ? 'Mapa de compras' : mpe.etapa,
                                                                        media_dias: (mpe.media_dias * 24).toFixed(2),
                                                                        setor: mpe.setor,
                                                                        cor: mpe.cor                                                                    
                                                                    }
                                                                )
                                                         );

                console.log("Resposta da API:", mediaDiasPorEtapa);
                //Removendo as médias por etapa que forem da Gestão de Processos
                mediaDiasPorEtapa = mediaDiasPorEtapa.filter(media => media.etapa != 'Gestão de Processos');

                //busca media de cada setor da empresa, removendo os que tiverem média 0
                let mediaDiasPorSetor = response.data.medias_por_setor.filter(m => m.media_dias > 0);
                
                let fluxosConsiderados = [];
                fluxosConsiderados = response.data.fluxos_considerados.map(fluxo => {
                    return ({
                        dataDecisao: fluxo.dataDecisao,
                        dias_desde_ultima_etapa: fluxo.dias_desde_ultima_etapa,
                        etapa: fluxo.etapa == 'Compras' ? 'Envio do MCP' : fluxo.etapa == 'Comprador' ? 'Mapa de compras' : fluxo.etapa,
                        solicitacao_id: fluxo.solicitacao_id,
                        usuario_id: fluxo.usuario_id ? fluxo.proximo_aprovador_id : null,
                        proximo_aprovador: fluxo.proximo_aprovador
                    });
                });

                //Removendo registros da etapa Gestão de Processos
                fluxosConsiderados = fluxosConsiderados.filter(fluxo => fluxo.etapa != 'Gestão de Processos');

                setCards(current => ({
                    ...current,
                    mediaGlobal: response.data.media_tempo_dias_por_etapa.toFixed(2).replace(".", ","),
                    totalProcessos: response.data.solicitacoes_consideradas,
                    mediaDuracaoSolicitacao: response.data.media_duracao_solicitacoes,
                    duracaoMedia: response.data.media_duracao_solicitacoes,
                    etapaMaisLonga: response.data.etapa_mais_lenta == 'Compras' ? 'Envio do MCP' : response.data.etapa_mais_lenta == 'Comprador' ? 'Mapa de compras' : response.data.etapa_mais_lenta || "...",
                    mediaGlobalPorEtapa: mediaDiasPorEtapa,
                    mediaPorSetor: mediaDiasPorSetor,
                    carregado: true,
                    solicitacoesDetalhadas: response.data.solicitacoes_detalhadas,
                    // fluxosConsiderados: response.data.fluxos_considerados
                    fluxosConsiderados: fluxosConsiderados
                }));
            }
        } catch (error) {
            toast.error(JSON.stringify(error));
        } finally {
            setLoading(false);
        }
    }

    const verProcessos = () => {
        setModalProcessos(true);
    }

    const CustomLabel = (props) => {
        const {
            x, y, width, height,
            value,
            fontSize = 12,
            decimalParaHora
        } = props;

        // Texto final que será renderizado
        const texto = value == 1
            ? `${decimalParaHora(value)}h`
            : `${decimalParaHora(value)}h ou ${(value / 24).toFixed(2).replace(".", ",")} dia(s)`;

        // --- ESTIMATIVA DE TAMANHO DO TEXTO ---
        const larguraAproximadaTexto = texto.length * (fontSize * 0.6);

        const podeFicarDentro = larguraAproximadaTexto < width - 4; // margem interna

        if (podeFicarDentro) {
            // INSIDE RIGHT
            return (
                <text
                    x={x + width - 4}
                    y={y + height / 2}
                    textAnchor="end"
                    dominantBaseline="central"
                    fontSize={fontSize}
                    fill="#222"
                >
                    {texto}
                </text>
            );
        } else {
            // RIGHT (externo)
            return (
                <text
                    x={x + width + 4}
                    y={y + height / 2}
                    textAnchor="start"
                    dominantBaseline="central"
                    fontSize={fontSize}
                    fill="#222"
                >
                    {texto}
                </text>
            );
        }
    };

    const buscarCriterioCentroCusto = async () => {                                                                                                                                                      
        const token = JSON.parse(localStorage.getItem('usuario')).token;                                                                                                                                         
        try {
            let _criterio = criterio.map(item => item.value).join(",");
            let _tiposPedido = tiposPedidoSelected.map(item => item.value).join(",");                                                                                                                                                                  
            const response = await api.get(`criterioCentroCusto?data_inicio=${dataInicial}&data_fim=${dataFinal}&aprovador=${aprovador?.value || ""}&localEstoque=${obraSelecionada || ""}&ordenarDecrescente=${ordenarDecrescente ? 'true' : 'false'}&criterio=${_criterio}&solicitacao=${idsProcessos || ""}&tipoPedido=${_tiposPedido}`, {                                                                                                                                              
                headers: { 'Authorization': 'Bearer ' + token }                                                                                                                                                  
            });                                                                                                                                                                                                  
            if (response.status === 200) {                                                                                                                                                                       
                //setDadosGrafico({ inner: response.data.inner, outer: response.data.outer, carregado: true });  
                 setDadosGrafico({ dados: response.data.dados, criterios: response.data.criterios, carregado: true });                                                                                                  
            }                                                                                                                                                                                                    
        } catch (error) {                                                                                                                                                                                        
            toast.error('Erro ao carregar gráfico de critérios');                                                                                                                                                
        }                                                                                                                                                                                                        
    };    

    //bellow add const function, that receives count days and save in useState qtdDiasAtraso:
    const salvarQtdDiasAtraso = (countDays) => {
        setQtdDiasAtraso(countDays);
    };

    return (
        <Stack backgroundColor="#F5F5F5" height="100vh">
            <Header mobile={mobile} />
            <Sidebar mobile={mobile} />

            <Stack ml={mobile ? "0px" : "280px"} mt={mobile ? "50px" : "40px"} overflow={mobile ? "auto" : "auto"} height={mobile ? "100%" : "100%"} p={mobile ? "20px" : "50px"}>
                <Stack flexDirection={mobile ? "column" : "row"} flexWrap={mobile ? "nowrap" : "wrap"} justifyContent={"space-between"} alignItems={"center"}>
                    <Stack mb={"20px"}>
                        <Stack flexDirection={"row"} alignItems={"center"}>
                            <LuTimerReset color="#1565c0" size={mobile ? 24 : 28} />
                            <Typography fontSize={mobile ? 20 : 26} fontWeight={"bold"} ml={"10px"}>Acompanhamento de Tempo</Typography>
                        </Stack>
                        <Typography fontSize={14} sx={{ color: "#777" }}>Visualize e acompanhe o tempo médio de duração das etapas de aprovação</Typography>
                    </Stack>
                </Stack>
                <Stack width={"100%"} flex={1} gap="15px">
                    <Button onClick={() => { tempoMedioEntreEtapas(); buscarCriterioCentroCusto(); }} loading={loading} sx={{ alignSelf: 'flex-end', gap: "6px" }}>
                        {cards.carregado ?
                            <Stack flexDirection={"row"} alignItems={"center"} gap={'8px'}>
                                <MdOutlineRefresh size={20} />
                                Atualizar
                            </Stack>
                            :
                            <Stack flexDirection={"row"} alignItems={"center"} gap={'8px'}>
                                <MdSearch size={20} />
                                Procurar
                            </Stack>
                        }
                    </Button>
                    <Stack bgcolor={"#fff"} p={"30px"} borderRadius={"20px"} flexDirection={mobile ? 'column' : 'column'} justifyContent={mobile ? 'flex-start' : 'space-between'} flexWrap="wrap" alignItems={mobile ? 'flex-start' : "flex-center"} gap={3}>
                        <Stack flexDirection={"row"} gap={10} flexWrap="wrap">
                            <Stack flex={1} gap={"5px"} width={mobile ? '100%' : 'auto'} minWidth={220}>
                                <Typography style={{ color: "#555" }}>Data Inicial*</Typography>
                                <Input value={dataInicial} onChange={(e) => setDataInicial(e.target.value)} type="date" sx={{ borderRadius: "10px" }} />
                            </Stack>
                            <Stack flex={1} gap={"5px"} width={mobile ? '100%' : 'auto'} minWidth={220}>
                                <Typography style={{ color: "#555" }}>Data Final*</Typography>
                                <Input value={dataFinal} onChange={(e) => setDataFinal(e.target.value)} type="date" sx={{ borderRadius: "10px" }} />
                            </Stack>
                            <Stack flex={1} gap={"5px"} width={mobile ? '100%' : 'auto'} minWidth={220}>
                                <Stack flexDirection={"row"} alignItems={"center"} gap={"5px"}>
                                    <LuUser style={{ color: "#555" }} />
                                    <Typography style={{ color: "#555" }}>Aprovador</Typography>
                                </Stack>
                                <Autocomplete
                                    placeholder="Nome do aprovador"
                                    options={aprovadores}
                                    value={aprovador}
                                    onChange={(e, value) => setAprovador({ label: value ? value.label : null, value: value ? value.value : null })}
                                />
                            </Stack>
                            <Stack flex={1} gap={"5px"} width={mobile ? '100%' : 'auto'} minWidth={220}>
                                <Stack flexDirection={"row"} alignItems={"center"} gap={"5px"}>
                                    <IoLocationOutline style={{ color: "#555" }} />
                                    <Typography style={{ color: "#555" }}>Número(s) da(s) Solicitação(ões)</Typography>
                                </Stack>
                                {/* nedd below a text field  */}
                                <Input placeholder="Ex.: 123,456,789" value={idsProcessos} onChange={(e) => setIdsProcessos(e.target.value)} />

                                {/* <Select defaultValue={""} value={tipoProcesso} onChange={(_, value) => setTipoProcesso(value)} placeholder="Escolha uma opção" sx={{ borderRadius: "10px" }}>
                                    {tiposProcessos.map((tipo, index) => {
                                        return (
                                            <Option key={index} value={tipo.value}>{tipo.label}</Option>
                                        );
                                    })}
                                </Select> */}
                            </Stack>
                        </Stack>

                        <Stack flexDirection={"row"} gap={10} flexWrap="wrap">
                            <Stack flex={1} gap={"5px"} width={mobile ? '100%' : 'auto'} mb="24px" minWidth={220}>
                                <Stack flexDirection={"row"} alignItems={"center"} gap={"5px"}>
                                    <IoLocationOutline style={{ color: "#555" }} />
                                    <Typography style={{ color: "#555" }}>Local de Estoque</Typography>
                                </Stack>
                                <Select defaultValue={""} value={obraSelecionada} onChange={(_, value) => setObraSelecionada(value)} placeholder="Escolha um local de estoque" sx={{ borderRadius: "10px" }}>
                                    {obras.map((obra, index) => {
                                        return (
                                            <Option key={index} value={obra.localEstoque}>{obra.localEstoque == "" ? obra.nomeLocal : (obra.localEstoque + " - " + obra.nomeLocal)}</Option>
                                        );
                                    })}
                                </Select>
                            </Stack>

                            <Stack flex={1} gap={"5px"} width={mobile ? '100%' : 'auto'} sx={{ minWidth: 220 }} >
                                <Stack flexDirection={"row"} alignItems={"center"} gap={"5px"}>
                                    <IoLocationOutline style={{ color: "#555" }} />
                                    <Typography style={{ color: "#555" }}>Critério</Typography>
                                </Stack>
                                {/* <Select value={criterio} onChange={(_, value) => setCriterio(value)} placeholder="Escolha um critério" sx={{ borderRadius: "10px" }}>
                                    <Option value="">Todos</Option>
                                    <Option value="ES">Estoque</Option>
                                    <Option value="MP">Máquina Parada</Option>
                                    <Option value="NO">Normal</Option>
                                    <Option value="UR">Urgente</Option>
                                </Select> */}
                                <MultipleSelect sx={{ borderRadius: "10px" }}
                                    value={criterio}
                                    onChange={(e) => setCriterio(e)}
                                    placeholder="Escolha um critério"
                                    isMulti
                                    options={criterioOptions}
                                    noOptionsMessage={() => "Sem opções"}
                                />

                            </Stack>

                            <Stack flex={1} gap={"5px"} width={mobile ? '100%' : 'auto'} sx={{ minWidth: 220 }} >
                                <Stack flexDirection={"row"} alignItems={"center"} gap={"5px"}>
                                    <IoLocationOutline style={{ color: "#555" }} />
                                    <Typography style={{ color: "#555" }}>Tipo de Pedido</Typography>
                                </Stack>
                                <MultipleSelect sx={{ borderRadius: "10px" }}
                                    value={tiposPedidoSelected}
                                    onChange={(e) => setTiposPedidoSelected(e)}
                                    placeholder="Escolha um tipo de pedido"
                                    isMulti
                                    options={tiposPedidoOptions}
                                    noOptionsMessage={() => "Sem opções"}
                                />
                            </Stack>
                        </Stack>

                    </Stack>

                    <Stack flexDirection={mobile ? 'column' : "row"} alignItems={mobile ? 'flex-start' : "center"}>
                        <Typography fontSize={14}>Filtros ativos:</Typography>
                        <Stack flexDirection={"row"} mt={mobile ? '5px' : '0px'} bgcolor={"#eee"} p={"2px 10px"} borderRadius={"5px"} ml={"15px"} gap={"6px"} alignItems={"center"}>
                            <MdDateRange color="#444" />
                            <Typography sx={{ color: "#444", fontSize: 14 }}>{formatarData(dataInicial)}</Typography>
                            <Typography sx={{ color: "#444", fontSize: 14 }}>-</Typography>
                            <Typography sx={{ color: "#444", fontSize: 14 }}>{formatarData(dataFinal)}</Typography>
                            {aprovador && aprovador.value && <Typography sx={{ color: "#444", fontSize: 14 }}>-</Typography>}
                            {aprovador && aprovador.value && <Typography sx={{ color: "#444", fontSize: 14 }}>{aprovadores.find(a => a.value == aprovador.value)?.label}</Typography>}
                            {obraSelecionada && <Typography sx={{ color: "#444", fontSize: 14 }}>-</Typography>}
                            {obraSelecionada && <Typography sx={{ color: "#444", fontSize: 14 }}>{obraSelecionada}</Typography>}
                        </Stack>
                    </Stack>

                    {cards.carregado ?
                        <Stack>
                            <Stack flexDirection={mobile ? 'column' : "row"} alignItems={mobile ? 'flex-start' : "center"} gap={"30px"}>
                                {/* <Tooltip arrow title={'Tempo em dias baseado nas datas de decisão do fluxo de aprovação, levando em consideração todos os processos encontrados com base nos filtros acima.'} color="primary" placement="right" variant={"solid"} sx={{ maxWidth: "300px" }}> */}
                                <Tooltip arrow title={'Todo o tempo de permanência das etapas de aprovação dos ' + cards.totalProcessos + ' processo(s) foram somados e divididos pela quantidade de etapas, trazendo assim uma média global em dias.'} color="primary" placement="right" variant={"solid"} sx={{ maxWidth: "300px" }}>
                                    <Stack flexDirection={"row"} justifyContent={'space-between'} flex={1} minWidth={'200px'} width={mobile ? '100%' : '280px'} alignItems={"center"} sx={{ backgroundColor: "white", padding: "16px", borderRadius: '10px', boxShadow: '2px 2px 5px #ddd' }}>
                                        <Stack gap={'10px'}>
                                            <Typography sx={{ color: "#777", fontWeight: "bold" }}>Média por Etapas</Typography>
                                            <Typography sx={{ fontWeight: "bold", fontSize: 20 }}>{cards.mediaGlobal} dia(s)</Typography>
                                            <Typography sx={{ fontSize: '12px', color: "#888" }}>Por etapa</Typography>
                                        </Stack>
                                        <TrendingUp size={20} color="#1e88e5" style={{ backgroundColor: "#e3f2fd", padding: "8px", fontSize: 12, borderRadius: "10px" }} />
                                    </Stack>
                                </Tooltip>

                                <Tooltip arrow title={'Foram considerados ' + cards.totalProcessos + ' processo(s) para o cálculo das médias e etapa mais longa.'} color="primary" placement="right" variant={"solid"} sx={{ maxWidth: "300px" }}>
                                    <Stack flexDirection={"row"} justifyContent={'space-between'} flex={1} minWidth={'200px'} width={mobile ? '90%' : "280px"} alignItems={"center"} sx={{ backgroundColor: "white", padding: "16px", borderRadius: '10px', boxShadow: '2px 2px 5px #ddd' }}>
                                        <Stack gap={'10px'} width={'100%'}>
                                            <Typography sx={{ color: "#777", fontWeight: "bold" }}>Total de Solicitações</Typography>
                                            <Typography sx={{ fontWeight: "bold", fontSize: 20 }}>{cards.totalProcessos}</Typography>
                                            <Stack justifyContent={'space-between'} flexDirection={"row"} alignItems={'center'}>
                                                <Typography sx={{ fontSize: '12px', color: "#888" }}>No período selecionado</Typography>
                                                <Link onClick={verProcessos} fontSize={12}>Ver processos</Link>
                                            </Stack>
                                        </Stack>
                                        <BarChart3 size={20} color="#1e88e5" style={{ backgroundColor: "#e3f2fd", padding: "8px", fontSize: 12, borderRadius: "10px" }} />
                                    </Stack>
                                </Tooltip>

                                <Tooltip arrow title={'Tempo médio em dias desde a abertura da solicitação até a conclusão do processo, considerando apenas processos finalizados e em andamento.'} color="primary" placement="right" variant={"solid"} sx={{ maxWidth: "300px" }}>
                                    <Stack flexDirection={"row"} justifyContent={'space-between'} flex={1} minWidth={'200px'} width={mobile ? '90%' : '280px'} alignItems={"center"} sx={{ backgroundColor: "white", padding: "16px", borderRadius: '10px', boxShadow: '2px 2px 5px #ddd' }}>
                                        <Stack gap={'10px'}>
                                            <Typography sx={{ color: "#777", fontWeight: "bold" }}>Média Ciclo de Vida da Solicitação</Typography>
                                            <Typography sx={{ fontWeight: "bold", fontSize: 20 , color: "#333"}}>{cards.mediaDuracaoSolicitacao || 0} dia(s)</Typography>
                                            <Typography sx={{ fontSize: '12px', color: "#888" }}>Global</Typography>
                                        </Stack>
                                        <TrendingUp size={20} color="#1e88e5" style={{ backgroundColor: "#e3f2fd", padding: "8px", fontSize: 12, borderRadius: "10px" }} />
                                    </Stack>
                                </Tooltip>

                                {/* <Tooltip arrow title={'Em média essa foi a etapa de aprovação com a maior duração dentre os processos analisados.'} color="primary" placement="left" variant={"solid"} sx={{ maxWidth: "300px" }}>
                                    <Stack flexDirection={"row"} justifyContent={'space-between'} flex={1} minWidth={'200px'} width={mobile ? '90%' : "280px"} alignItems={"center"} sx={{ backgroundColor: "white", padding: "16px", borderRadius: '10px', boxShadow: '2px 2px 5px #ddd' }}>
                                        <Stack gap={'10px'}>
                                            <Typography sx={{ color: "#777", fontWeight: "bold" }}>Etapa mais Longa</Typography>
                                            <Typography sx={{ fontWeight: "bold", fontSize: 20 }}>{cards.etapaMaisLonga}</Typography>
                                            <Typography sx={{ fontSize: '12px', color: "#888" }}>Em média foi a etapa que mais demorou</Typography>
                                        </Stack>
                                        <ClockAlert size={20} color="#1e88e5" style={{ backgroundColor: "#e3f2fd", padding: "8px", fontSize: 12, borderRadius: "10px" }} />
                                    </Stack>
                                </Tooltip> */}

                                {/* <Tooltip arrow title={'Em média essa foi a etapa de aprovação com a maior duração dentre os processos analisados.'} color="primary" placement="left" variant={"solid"} sx={{ maxWidth: "300px" }}>
                                    <Stack flexDirection={"row"} justifyContent={'space-between'} flex={1} minWidth={'200px'} width={mobile ? '90%' : "auto"} alignItems={"center"} sx={{ backgroundColor: "white", padding: "16px", borderRadius: '10px', boxShadow: '2px 2px 5px #ddd' }}>
                                        <Stack gap={'10px'}>
                                            <Typography sx={{ color: "#777", fontWeight: "bold" }}>Novo Card</Typography>
                                            <Typography sx={{ fontWeight: "bold", fontSize: 20 }}>Sit Amet</Typography>
                                            <Typography sx={{ fontSize: '12px', color: "#888" }}>consectetur adispicing elit</Typography>
                                        </Stack>
                                        <ClockAlert size={20} color="#1e88e5" style={{ backgroundColor: "#e3f2fd", padding: "8px", fontSize: 12, borderRadius: "10px" }} />
                                    </Stack>
                                </Tooltip>                                 */}
                                {/* <Tooltip arrow title={'Duração média dos processos analisados desde o momento da solicitação até a conclusão.'} color="primary" placement="left" variant={"solid"} sx={{ maxWidth: "300px" }}>
                                    <Stack flexDirection={"row"} justifyContent={'space-between'} flex={1} minWidth={'200px'} maxWidth={"280px"} alignItems={"center"} sx={{ backgroundColor: "white", padding: "16px", borderRadius: '10px', boxShadow: '2px 2px 5px #ddd' }}>
                                        <Stack gap={'10px'}>
                                            <Typography sx={{ color: "#777", fontWeight: "bold" }}>Duração média</Typography>
                                            <Typography sx={{ fontWeight: "bold", fontSize: 20 }}>{cards.duracaoMedia.toString().replace(".", ",")} dia(s)</Typography>
                                            <Typography sx={{ fontSize: '12px', color: "#888" }}>Média dos processos contabilizados</Typography>
                                        </Stack>
                                        <Clock size={20} color="#1e88e5" style={{ backgroundColor: "#e3f2fd", padding: "8px", fontSize: 12, borderRadius: "10px" }} />
                                    </Stack>
                                </Tooltip> */}
                            </Stack>

                            <Stack flexDirection={mobile ? 'column' : "row"} alignItems={mobile ? 'flex-start' : "center"} gap={"30px"} mt={"20px"}> 
                                {/* <Tooltip arrow title={'Tempo em dias baseado nas datas de decisão do fluxo de aprovação, levando em consideração todos os processos encontrados com base nos filtros acima.'} color="primary" placement="right" variant={"solid"} sx={{ maxWidth: "300px" }}> */}

                                <Tooltip arrow title={'Média de tempo das etapas administrativas.'} color="primary" placement="right" variant={"solid"} sx={{ maxWidth: "300px" }}>
                                    <Stack flexDirection={"row"} justifyContent={'space-between'} flex={1} minWidth={'200px'} width={mobile ? '90%' : '280px'} alignItems={"center"} sx={{ backgroundColor: "white", padding: "16px", borderRadius: '10px', boxShadow: '2px 2px 5px #ddd' }}>
                                        <Stack gap={'10px'}>
                                            <Typography sx={{ color: "#777", fontWeight: "bold" }}>Média Administrativo</Typography>
                                            <Typography sx={{ fontWeight: "bold", fontSize: 20 , color: cards.mediaPorSetor?.[0]?.cor || "#333"}}>{cards.mediaPorSetor?.[0]?.media_dias || 0} dia(s)</Typography>
                                            <Typography sx={{ fontSize: '12px', color: "#888" }}>Por setor</Typography>
                                        </Stack>
                                        <TrendingUp size={20} color="#1e88e5" style={{ backgroundColor: "#e3f2fd", padding: "8px", fontSize: 12, borderRadius: "10px" }} />
                                    </Stack>
                                </Tooltip>

                                <Tooltip arrow title={'Média de tempo das etapas de compras.'} color="primary" placement="right" variant={"solid"} sx={{ maxWidth: "300px" }}>
                                    <Stack flexDirection={"row"} justifyContent={'space-between'} flex={1} minWidth={'200px'} width={mobile ? '90%' : "280px"} alignItems={"center"} sx={{ backgroundColor: "white", padding: "16px", borderRadius: '10px', boxShadow: '2px 2px 5px #ddd' }}>
                                        <Stack gap={'10px'} width={'100%'}>
                                            <Typography sx={{ color: "#777", fontWeight: "bold" }}>Média Compras</Typography>
                                            <Typography sx={{ fontWeight: "bold", fontSize: 20 , color: cards.mediaPorSetor?.[1]?.cor || "#333"}}>{cards.mediaPorSetor?.[1]?.media_dias || 0} dia(s)</Typography>
                                            <Stack justifyContent={'space-between'} flexDirection={"row"} alignItems={'center'}>
                                                <Typography sx={{ fontSize: '12px', color: "#888" }}>Por setor</Typography>
                                            </Stack>
                                        </Stack>
                                        <BarChart3 size={20} color="#1e88e5" style={{ backgroundColor: "#e3f2fd", padding: "8px", fontSize: 12, borderRadius: "10px" }} />
                                    </Stack>
                                </Tooltip>

                                <Tooltip arrow title={'Média de tempo das etapas de obra.'} color="primary" placement="left" variant={"solid"} sx={{ maxWidth: "300px" }}>
                                    <Stack flexDirection={"row"} justifyContent={'space-between'} flex={1} minWidth={'200px'} width={mobile ? '90%' : "280px"} alignItems={"center"} sx={{ backgroundColor: "white", padding: "16px", borderRadius: '10px', boxShadow: '2px 2px 5px #ddd' }}>
                                        <Stack gap={'10px'}>
                                            <Typography sx={{ color: "#777", fontWeight: "bold" }}>Média Obra</Typography>
                                            <Typography sx={{ fontWeight: "bold", fontSize: 20 , color: cards.mediaPorSetor?.[2]?.cor || "#333"}}>{cards.mediaPorSetor?.[2]?.media_dias || 0} dia(s)</Typography>
                                            <Typography sx={{ fontSize: '12px', color: "#888" }}>Por setor</Typography>
                                        </Stack>
                                        <ClockAlert size={20} color="#1e88e5" style={{ backgroundColor: "#e3f2fd", padding: "8px", fontSize: 12, borderRadius: "10px" }} />
                                    </Stack>
                                </Tooltip>

                                <Tooltip arrow title={'Média de tempo das etapas de diretoria.'} color="primary" placement="left" variant={"solid"} sx={{ maxWidth: "300px" }}>
                                    <Stack flexDirection={"row"} justifyContent={'space-between'} flex={1} minWidth={'200px'} width={mobile ? '90%' : "280px"} alignItems={"center"} sx={{ backgroundColor: "white", padding: "16px", borderRadius: '10px', boxShadow: '2px 2px 5px #ddd' }}>
                                        <Stack gap={'10px'}>
                                            <Typography sx={{ color: "#777", fontWeight: "bold" }}>Média Diretoria</Typography>
                                            <Typography sx={{ fontWeight: "bold", fontSize: 20 , color: cards.mediaPorSetor?.[3]?.cor || "#333"}}>{cards.mediaPorSetor?.[3]?.media_dias || 0} dia(s)</Typography>
                                            <Typography sx={{ fontSize: '12px', color: "#888" }}>Por setor</Typography>
                                        </Stack>
                                        <ClockAlert size={20} color="#1e88e5" style={{ backgroundColor: "#e3f2fd", padding: "8px", fontSize: 12, borderRadius: "10px" }} />
                                    </Stack>
                                </Tooltip>

                            </Stack>

                            <Stack mt={"20px"} sx={{ backgroundColor: "#fff", borderRadius: "10px" }}>
                                <Stack flexDirection={"row"} alignItems={"center"} gap={"10px"} padding={"15px"} paddingBottom={"16px"} borderBottom={"1px solid #ddd"}>
                                    <BarChart3 size={20} color="#1e88e5" style={{ backgroundColor: "#e3f2fd", padding: "8px", fontSize: 12, borderRadius: "10px" }} />
                                    <Stack gap={'2px'}>
                                        <Typography sx={{ fontWeight: "bold", fontSize: 16 }}>Tempo Médio Global por Etapa</Typography>
                                        <Typography sx={{ fontSize: '12px', color: "#888" }}>Tempo médio em dias considerando todos os processos</Typography>
                                    </Stack>
                                    <Stack ml={'10px'} flexDirection={'row'} alignItems={'center'} gap={1}>
                                        <Switch checked={ordenarDecrescente} onChange={(event) => setOrdenarDecrescente(event.target.checked)} />
                                        <Typography>Ordenar decrescente</Typography>
                                    </Stack>
                                    <Stack ml={'10px'} flexDirection={'row'} alignItems={'center'} gap={1}>
                                        <Switch checked={buscaAtrasados} onChange={(event) => setBuscaAtrasados(event.target.checked)} />
                                        <Typography>Processos parados por etapa</Typography>
                                    </Stack>

                                    {/* bellow add a button white with label "10 dias" */}
                                    {buscaAtrasados && (
                                        <Stack flexDirection="row" gap={1} marginLeft={"auto"}>
                                            <Button onClick={() => { salvarQtdDiasAtraso(2); setAtrasoSelecionado("2") }} variant="contained" sx={{ backgroundColor: atrasoSelecionado === "2" ? "#1976d2" : "#fff", color: atrasoSelecionado === "2" ? "#fff" : "#333", border: "1px solid #ccc" }}>
                                                2 dias
                                            </Button>
                                            <Button onClick={() => { salvarQtdDiasAtraso(5); setAtrasoSelecionado("5") }} variant="contained" sx={{ backgroundColor: atrasoSelecionado === "5" ? "#1976d2" : "#fff", color: atrasoSelecionado === "5" ? "#fff" : "#333", border: "1px solid #ccc" }}>
                                                5 dias
                                            </Button>
                                            <Button onClick={() => { salvarQtdDiasAtraso(10); setAtrasoSelecionado("10") }} variant="contained" sx={{ backgroundColor: atrasoSelecionado === "10" ? "#1976d2" : "#fff", color: atrasoSelecionado === "10" ? "#fff" : "#333", border: "1px solid #ccc" }}>
                                                +10 dias
                                            </Button>
                                        </Stack>
                                    )}
                                </Stack>

                                <Stack padding={"15px"}>
                                    <BarChart
                                        key={cards.mediaGlobalPorEtapa}
                                        style={{ width: '100%', maxWidth: '100%', maxHeight: (cards.mediaGlobalPorEtapa.length * 150), aspectRatio: 1.618 }}
                                        responsive
                                        data={cards.mediaGlobalPorEtapa}
                                        layout="vertical"
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />

                                        <YAxis
                                            dataKey="etapa"
                                            type="category"
                                            width={200}
                                        />

                                        <XAxis
                                            type="number"
                                            label={{
                                                value: "Tempo em Dias",
                                                position: "insideBottom",
                                                offset: -3,  // aumenta a distância vertical
                                                fontWeight: 'bold'
                                            }}
                                        />
                                        <RechartsTooltip
                                            content={({ payload, label }) => {
                                                if (!payload || payload.length === 0) return null;

                                                const item = payload[0];

                                                return (
                                                    <div style={{
                                                        background: "white",
                                                        border: "1px solid #ccc",
                                                        padding: "10px",
                                                        borderRadius: "8px"
                                                    }}>
                                                        <Typography>{label}</Typography>
                                                        <Typography>Duração: <Typography fontWeight={'bold'}>{decimalParaHora(item.value)}h</Typography></Typography>
                                                        <Typography>Duração: <Typography fontWeight={'bold'}>{((item.value) / 24).toFixed(2)} dia(s)</Typography></Typography>
                                                    </div>
                                                );
                                            }}
                                        />

                                        <Bar
                                            dataKey="media_dias"
                                            name="Etapa de Aprovação"
                                            isAnimationActive={true}
                                            fillOpacity={0.25}
                                            onClick={(data, index) => analisarEtapa(data)}
                                            maxBarSize={50}
                                        >
                                            {cards.mediaGlobalPorEtapa.map((entry, index) => {
                                                let color;
                                                console.log(entry);
                                                if (entry.setor == "diretoria") color = entry.cor;       // verde - bom
                                                else if (entry.setor == "compras") color = entry.cor;  // amarelo - atenção
                                                else if (entry.setor == "requisicao") color = entry.cor;  // laranja - ruim
                                                else if (entry.setor == "obra") color = entry.cor;
                                                else color = "#E53935";                       // vermelho - crítico

                                                return (
                                                    <Cell
                                                        key={index}
                                                        fill={color}
                                                        stroke={color}
                                                        strokeWidth={2}
                                                    />
                                                );
                                            })}

                                            {/* Labels para exibir o valor */}
                                            {/* <LabelList
                                                dataKey="media_dias"
                                                position="insideRight"
                                                fontSize={12}
                                                fill="#555"
                                                formatter={(value) => value == 1 ? `${decimalParaHora(value)}h` : `${decimalParaHora(value)}h ou ${(value / 24).toFixed(2).replace(".", ",")} dia(s)`}
                                            /> */}
                                            <LabelList
                                                dataKey="media_dias"
                                                content={(props) => (
                                                    <CustomLabel
                                                        {...props}
                                                        fontSize={12}
                                                        decimalParaHora={decimalParaHora}
                                                    />
                                                )}
                                            />

                                        </Bar>
                                    </BarChart>
                                </Stack>
                            </Stack>

                        {/* Novo Grafico Local Estoque x Critério */}

                        {/* fim novo grafico */}
                        </Stack>
                        :
                        <Stack flex={1} justifyContent={'center'} alignItems={'center'}>
                            <MdAccessTime size={100} color="#ddd" />
                            <Typography sx={{ color: "#888" }}>Aguardando a primeira busca</Typography>
                        </Stack>
                    }
                </Stack>
            </Stack>

            <Modal
                aria-labelledby="modal-title"
                aria-describedby="modal-desc"
                open={modalProcessos}
                disableScrollLock={true}
                onClose={() => setModalProcessos(false)}
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <Sheet
                    variant="outlined"
                    sx={{
                        minWidth: mobile ? "70%" : "800px",
                        maxWidth: "80vw",
                        maxHeight: "80%",
                        borderRadius: 'md',
                        p: 3,
                        boxShadow: 'lg',
                        overflowY: "hidden",
                        overflowX: "hidden"
                    }}
                >
                    <ModalClose
                        variant="outlined"
                        sx={{
                            top: 'calc(0.3 * var(--IconButton-size))',
                            right: 'calc(0.3 * var(--IconButton-size))',
                            boxShadow: '0 2px 12px 0 rgba(0 0 0 / 0.2)',
                            borderRadius: '50%',
                            bgcolor: 'background.surface',
                        }}
                    />
                    <Typography
                        component="h2"
                        id="modal-title"
                        level="h4"
                        textColor="inherit"
                        fontWeight="normal"
                        mb={1}
                        sx={{ color: "#333" }}>
                        <div>
                            <label style={{ fontWeight: "bold" }}>Processos Contabilizados</label>
                        </div>
                    </Typography>
                    <Typography sx={{ fontWeight: 'bold' }}>Duração</Typography>
                    <Stack sx={{ backgroundColor: "#eee", padding: "5px 10px", borderRadius: '5px' }}>
                        <Typography fontSize={'14px'}>Menor : {cards.solicitacoesDetalhadas.length > 0 ? cards.solicitacoesDetalhadas.reduce((min, item) => item.duracao_dias < min.duracao_dias ? item : min).duracao_dias : ""} dia(s)</Typography>
                        <Typography fontSize={'14px'}>Maior : {cards.solicitacoesDetalhadas.length > 0 ? cards.solicitacoesDetalhadas.reduce((max, item) => item.duracao_dias > max.duracao_dias ? item : max).duracao_dias : ""} dia(s)</Typography>
                    </Stack>
                    <Stack>
                        <Stack sx={{ overflowY: 'auto', maxHeight: '70vh' }}>
                            <Table sx={{ width: '800px' }} aria-label="basic table">
                                <thead>
                                    <tr>
                                        <th style={{ padding: "0px 0px 5px 0px", width: '90px' }}>Solicitação</th>
                                        {/* <th style={{ padding: "0px 0px 5px 0px" }}>Nome do Solicitante</th> */}
                                        <th style={{ padding: "0px 0px 5px 0px" }}>Nome do Solicitante</th>
                                        <th style={{ padding: "0px 0px 5px 0px", width: '110px' }}>Iniciado em</th>
                                        <th style={{ padding: "0px 0px 5px 0px", width: '110px' }}>Atualizado em</th>
                                        <th style={{ padding: "0px 0px 5px 0px", width: '60px' }}>Duração</th>
                                        <th style={{ padding: "0px 0px 5px 10px", width: '100px' }}>Etapa</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cards.solicitacoesDetalhadas.map((value, index) => {
                                        return (
                                            <tr key={index}>
                                                <td style={{ padding: "0px" }}><Link onClick={() => window.open('/solicitacao/' + value.id)}>{value.id}</Link></td>
                                                <td style={{ padding: "0px" }}>{usuarios.find(u => u.value == value.usuario_id)?.label}</td>
                                                <td style={{ padding: "0px" }}>{formatarData(value.created_at)}</td>
                                                <td style={{ padding: "0px" }}>{formatarData(value.updated_at)}</td>
                                                <td style={{ padding: "0px", textAlign: "center" }}>{value.duracao_dias} dia(s)</td>
                                                <td style={{ padding: "0px", textAlign: "center" }}>{value.etapa}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </Stack>
                    </Stack>
                </Sheet>
            </Modal>

            <Modal
                aria-labelledby="modal-title"
                aria-describedby="modal-desc"
                open={modalProcessosPorEtapa}
                disableScrollLock={true}
                onClose={() => setModalProcessosPorEtapa(false)}
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <Sheet
                    variant="outlined"
                    sx={{
                        minWidth: mobile ? "70%" : "800px",
                        maxWidth: "80vw",
                        maxHeight: "80%",
                        borderRadius: 'md',
                        p: 3,
                        boxShadow: 'lg',
                        overflowY: "hidden",
                        overflowX: "hidden"
                    }}
                >
                    <ModalClose
                        variant="outlined"
                        sx={{
                            top: 'calc(0.3 * var(--IconButton-size))',
                            right: 'calc(0.3 * var(--IconButton-size))',
                            boxShadow: '0 2px 12px 0 rgba(0 0 0 / 0.2)',
                            borderRadius: '50%',
                            bgcolor: 'background.surface',
                        }}
                    />
                    <Typography
                        component="h2"
                        id="modal-title"
                        level="h4"
                        textColor="inherit"
                        fontWeight="normal"
                        mb={1}
                        sx={{ color: "#333" }}>
                        <div>
                            <label style={{ fontWeight: "bold" }}>Detalhamento dos Processos</label>
                        </div>
                    </Typography>
                    <Stack>
                        <Stack mb={'6px'}>
                            <Typography>Etapa selecionada: <Typography fontWeight={"bold"}>{dadosEtapaConsultada?.etapa}</Typography></Typography>
                            <Typography sx={{ color: "#555", backgroundColor: "#eee", alignSelf: "flex-start", borderRadius: "5px", padding: "2px 10px" }} fontSize={"14px"} mt={'10px'}>{cards.fluxosConsiderados.filter(fc => fc.etapa == dadosEtapaConsultada?.etapa).length} aprovação(s) considerada(s) no cálculo:</Typography>
                        </Stack>
                        <Stack sx={{ overflowY: 'auto', maxHeight: '70vh' }}>
                            <Table sx={{ width: '800px' }} aria-label="basic table">
                                <thead>
                                    <tr>
                                        <th style={{ padding: "0px 0px 5px 0px", width: '90px' }}>Solicitação</th>
                                        {/* <th style={{ padding: "0px 0px 5px 0px" }}>Nome do Solicitante</th> */}
                                        <th style={{ padding: "0px 0px 5px 0px" }}>Nome do Aprovador</th>
                                        <th style={{ padding: "0px 0px 5px 0px", width: '150px' }}>Decisão em</th>
                                        <th style={{ padding: "0px 0px 5px 0px", width: '110px' }}>Duração(dias)</th>
                                        <th style={{ padding: "0px 0px 5px 0px", width: '110px' }}>Duração(horas)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cards.fluxosConsiderados.map((value, index) => {
                                        if ((value.etapa == dadosEtapaConsultada?.etapa) && value.dias_desde_ultima_etapa) {
                                            console.log("Próximo aprovador:", value);
                                            return (
                                                
                                                <tr key={index}>
                                                    <td style={{ padding: "0px" }}><Link onClick={() => window.open('/fluxoAprovacao/' + value.solicitacao_id)}>{value.solicitacao_id}</Link></td>
                                                    <td style={{ padding: "0px" }}>{usuarios?.find(u => u.value == value.usuario_id)?.label ?? value.proximo_aprovador ?? 'Sem aprovador'}</td>
                                                    <td style={{ padding: "0px" }}>{formatarData(value.dataDecisao.split(" ")[0]) + " as " + value.dataDecisao.split(" ")[1].slice(0, 5)}</td>
                                                    <td style={{ padding: "0px", textAlign: "center" }}>{value.dias_desde_ultima_etapa?.toFixed(2)?.replace(".", ",")}</td>
                                                    <td style={{ padding: "0px", textAlign: "center" }}>{decimalParaHora(value.dias_desde_ultima_etapa * 24)}</td>
                                                </tr>
                                            );
                                        }
                                    })}
                                </tbody>
                            </Table>
                        </Stack>
                    </Stack>
                </Sheet>
            </Modal>
        </Stack >
    );
}